import R from 'ramda';
import createUserFirebase from './createUserFirebase';

const initialState = {
  // Undefined is absence of evidence, null is evidence of absence.
  online: undefined,
  viewer: undefined,
  userDetails: undefined,
};

const reducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {

    case 'ON_AUTH': {
      const user = createUserFirebase(action.payload.firebaseUser);
      return { ...state, viewer: user };
    }

    case 'SIGN_OUT':
      return { ...state, viewer: null };

    case 'ON_USERS_PRESENCE': {
      const { presence } = action.payload;
      if (!presence) {
        return { ...state, online: null };
      }
      const sortBylastSeenAt = R.sortBy(R.prop('lastSeenAt'));
      const online = R.compose(
        R.map(item => item.user),
        R.sortBy(sortBylastSeenAt),
        R.values,
        R.map(R.compose(R.last, sortBylastSeenAt, R.values)),
      )(presence);
      return { ...state, online };
    }

    case 'ON_USER_DETAILS_PRESENCE': {
      const { userDetails } = action.payload;
      if (!userDetails) {
        return { ...state, userDetails: null };
      }

      return { ...state, userDetails };
    }

    default:
      return state;

  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/common/users/reducer.js